"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackyAutoFocusIndicator = exports.autoFocus = void 0;
var tslib_1 = require("tslib");
var tabbable_1 = require("tabbable");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var FocusIndicators_1 = require("../styles/FocusIndicators");
/**
 *
 * @param disableAutoFocus The value from the prop
 * @param container The container to query for focusable elements
 * @param shiftFirstElement A `true` value, will take the first focusable element and move it to the end of the stack.
 * In almost all cases, this will be for when the first focusable element is a close button.
 */
function autoFocus(disableAutoFocus, container, shiftFirstElement) {
    if (disableAutoFocus === true) {
        return;
    }
    var getElementToFocus = typeof disableAutoFocus === 'function' ?
        disableAutoFocus :
        function (widgetElement) {
            var tabbables = tabbable_1.tabbable(widgetElement);
            if (tabbables.length === 0) {
                throw Error('Something within the widget must be focusable per a11y requirements');
            }
            // move the close button to the back of the line, i.e. only focus on it if there was nothing else focusable
            if (shiftFirstElement) {
                tabbables.push(tabbables.shift());
            }
            return tabbables[0];
        };
    var elementToFocus = getElementToFocus(container);
    if (!elementToFocus) {
        throw Error('No focusable element was returned by the `disableAutoFocus` callback');
    }
    else if (!container.contains(elementToFocus)) {
        throw Error("Can't auto-focus an element outside of the widget");
    }
    // Queue this so that it occurs after the floater or overlay is positioned,
    // so that when the browser scrolls to the focused element it will scroll to the correct position.
    // Also, a React component being mounted doesn't necessarily mean it is attached to the document;
    // gating behind a setTimeout is a usually-safe bet that the component has been attached.
    window.setTimeout(function () {
        if (!document.contains(elementToFocus)) {
            return;
        }
        elementToFocus.focus();
        if (isButton(elementToFocus)) {
            elementToFocus.classList.add(exports.HackyAutoFocusIndicator);
            document.addEventListener('blur', function (e) {
                if (e.target === elementToFocus) {
                    elementToFocus.classList.remove(exports.HackyAutoFocusIndicator);
                }
            }, { capture: true, once: true });
        }
    });
}
exports.autoFocus = autoFocus;
/**
 * As of Apr 2022, :focus-visible doesn't match when focus moves programmatically into a dialog.
 * We think that dialog auto-focused buttons should show the focus indicator regardless of input modality, hence this nonstandard focus indicator.
 * https://github.com/w3c/csswg-drafts/issues/3080 <-- ckovatch's likely hopeless attempt to change the world.
 */
exports.HackyAutoFocusIndicator = TypeStyle.style(tslib_1.__assign({ $unique: true }, FocusIndicators_1.DefaultFocusIndicator({ inset: true })));
var isButton = function (element) { return element instanceof HTMLButtonElement; };
//# sourceMappingURL=AutoFocus.js.map